import { IProductFieldsFragment } from "@govlaunch/product/src/fragments/__generated__/ProductFieldsFragment.generated";
import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";

export default function canSeeGovernmentsUsing(product: IProductFieldsFragment, viewer: ISelfieQuery["selfie"] | null) {
  if (!viewer) {
    return false;
  }

  if (!product.company || product.company.plan.name === "Basic") {
    return false;
  }

  if (viewer.__typename === "GovernmentUser") {
    return true;
  }

  if (viewer.__typename === "VendorUser" && viewer.company?._id === product.company._id) {
    return true;
  }

  return false;
}
